import auth from '@/Middlewares/auth.js'
import ResourceRoute from '@/Setup/Routes/ResourceRoute.js'
import RouteGroup from '@/Setup/Routes/RouteGroup.js'

export const settingRoutes = new RouteGroup(() => {
  return [
    ...new ResourceRoute('settings', {
      list: () => import(/* webpackChunkName: "admin" */ './Pages/List.vue'),
    })
      .permissions({
        list: 'reports.view',
      })
      .only(['list'])
      .resolve(),
  ]
})
  .middlewares([auth])
  .resolve()
